import './bootstrap';

import * as bootstrap from 'bootstrap';

window.bootstrap = bootstrap;

// Livewire handles Alpine automatically
// import Alpine from 'alpinejs';

// window.Alpine = Alpine;

// Alpine.start();
